import { createReducer, on } from "@ngrx/store";
import { ClickUpStateInterface } from "./clickUpState.interface";
import { resultCreateClickUpTask } from "./clickUp.actions";

export const initialState: Readonly<ClickUpStateInterface> = {
  result: null,
};
export const ClickUpReducer = createReducer(
  initialState,
  on(resultCreateClickUpTask, (state) => ({
    ...state,
  }))
);
